import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import MyLink from "../../components/myLink";
import Note from "../../components/note";
import Caution from "../../components/caution";
import PainScaleImg from "../../components/painScaleImg";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/2/1.0-routine-patient-care" mdxType="MyLink">
        1.0 Routine Patient Care
      </MyLink>
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <h4 id="advanced-adult" style={{
        marginBottom: '0.15rem'
      }}>
    <a href="#advanced-adult">
      Adult:
    </a>
  </h4>
  <ul>
    <li>
      Ondansetron 4 mg PO (Oral Disintegrating Tablet (ODT) is the preferred route)
      IV/IO/IM.
    </li>
  </ul>
  <h4 id="advanced-pedi" style={{
        marginBottom: '0.15rem'
      }}>
    <a href="#advanced-pedi">
      Pediatric:
    </a>
  </h4>
  <ul>
    <li>
      Ondansetron for child under or up to 25 kg 2 mg PO by Oral Disintegrating
      Tablet (ODT).ODT is the preferred route /IV/IM;
      for a child over 25 kg, 4 mg PO by ODT(the preferred route)/IV/IM.
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <h4 id="paramedic-adult" style={{
        marginBottom: '0.15rem'
      }}>
    <a href="#paramedic-adult">
      Adult:
    </a>
  </h4>
  <ul>
    <li>Acetaminophen 650-1000 mg IV or PO.</li>
    <li>Ibuprofen 600 mg PO.</li>
    <li>Ketorolac 15 mg IV or 30 mg IM.</li>
    <li>
      Fentanyl 1 mcg/kg slow IV/IO/IM weight based (kg) to a max. of 150mcg
      (150kg) or
      Fentanyl 1 mcg/kg IN weight based (kg) to a max. of 150mcg
      (150kg).
    </li>
    <li>Morphine Sulfate 0.1mg/kg IV/IO/IM/SC,(max 10 mg).</li>
    <li>
      Ketamine 0.3-0.5 mg/kg IV/IO SLOWLY-may repeat dose one time in 10 minutes
    or 1 mg/kg IM/IN-may repeat IM/IN dose one time in 20 minutes.
    </li>
    <li>
      For patients requiring electrical therapy (cardioversion or pacing) see 
      <MyLink to="/sections/7/7.6-sedation-and-analgesia-for-electrical-therapy" mdxType="MyLink">
        7.6 Sedation and Analgesia for Electrical Therapy-Adult
      </MyLink>
      <br />
      Consider ketamine.
    </li>
  </ul>
  <h4 id="paramedic-pedi" style={{
        marginBottom: '0.15rem'
      }}>
    <a href="#paramedic-pedi">
      Pediatric:
    </a>
  </h4>
  <ul>
    <li>Acetaminophen 15 mg/kg IV or PO to max 1000 mg.</li>
    <li>Ibuprofen 10 mg/kg PO to max 600 mg.</li>
    <li>Ketorolac 0.5 mg/kg IV or IM to max 15 mg.</li>
    <li>
      Fentanyl 1 mcg/kg. to max. 150 mcg slow IV/IO/IM or
      Fentanyl 1 mcg/kg. to max. 150 mcg IN.
    </li>
    <li>Morphine Sulfate 0.1 mg/kg IV/IO/IM/SC (maximum individual 5 mg)</li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" medControl={true} mdxType="EMTLevel">
  <ul>
    <li>
      Additional doses of above medication
    </li>
  </ul>
    </EMTLevel>
    <PainScaleImg mdxType="PainScaleImg" />
    <Note id="note-1" mdxType="Note">
   Pain Management can include positioning, ice packs and other nonpharmacological treatments.
    </Note>
    <Note id="note-2" alignment="left" mdxType="Note">
  All pain medications have contraindications-do not administer
  medications in such circumstances. 
  <br /><br />
  These contraindications include but
  are not limited to: 
  <br /><br />
  Ketorolac and ibuprofen are contraindicated in
  head injury, chest pain, abdominal pain, or in any patient with
  potential for bleeding, ulcer, or renal injury; likely to need surgery
  <br /><br />
  Acetaminophen is contraindicated in patients with liver failure.
  <br /><br />
  Ketorolac and ibuprofen are contraindicated in pregnancy.
    </Note>
    <Caution id="caution-1" mdxType="Caution">
  Ondansetron is contraindicated in patients with prolonged QT interval.
    </Caution>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      